import { FC, useMemo } from "react";
import { Stack, Typography } from "@mui/material";
import { getMissingSubAccountsRoleTableColumns } from "./missingSubAccountsRoleTableColumns";
import { DataGrid } from "../../../../../../storybook/data-grid/DataGrid";
import { Account } from "../../../../../../services/cloudchipr.api";

interface AccountsDataGridProps {
  accounts: Account[] | null;
  onSortingChange?: (data: Account[], drop?: boolean) => void;
}

export const AccountsMissingRoleAccounts: FC<AccountsDataGridProps> = ({
  accounts,
  onSortingChange,
}) => {
  const columns = useMemo(() => {
    return getMissingSubAccountsRoleTableColumns();
  }, []);

  if (!accounts?.length) {
    return null;
  }

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" fontWeight="medium">
        Missing Role Accounts ({accounts.length})
      </Typography>
      <DataGrid
        enableRowDnD
        styles={styles}
        data={accounts}
        columns={columns}
        onRowsDndChange={onSortingChange}
        includeHeader={false}
      />
    </Stack>
  );
};

const styles = {
  tableHeaderRow: { borderTop: 1, borderColor: "grey.300" },
  tableContainer: {
    border: 1,
    borderBottom: 0,
    borderColor: "grey.300",
    borderRadius: 2,
  },
};
